// extracted by mini-css-extract-plugin
export default {"overview-info-general":"DAV4QWMss8","overviewInfoGeneral":"DAV4QWMss8","table":"_7m4+D84nED","attributes":"_984gFoR2CR","attributes-entry":"_4G28FJo91Y","attributesEntry":"_4G28FJo91Y","last-child":"D99FJENpx4","lastChild":"D99FJENpx4","key":"qChSFiWRz0","value":"jujPtalNIj","tabs":"tWXPWeo3QQ","tabs-general":"ya0EQAhQwI","tabsGeneral":"ya0EQAhQwI"};
    if(module.hot) {
      // 1650538150386
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  